import { CurrencyUsdIcon } from './CurrencyUsdIcon';

/**
 * author: Google
 * id 3FA4946C-029B-42D3-AA31-3D607FB4A2F1
 * name currency-usd
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-usd.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const AttachMoneyIcon = CurrencyUsdIcon;
export default AttachMoneyIcon